import axios from 'axios'

import environment from '../../variables/variables'

const requestResetPassword = (cancelToken, email) => {
  return axios({
    url: environment === "production"
          ? "https://3dmss-api.bscs.org" : "http://127.0.0.1:8000",
    method: "post",
    cancelToken: cancelToken.token,
    // withCredentials: true, //Must include this to send cookies
    rejectUnauthorized: false,
    data: {
      query: `
        mutation {
          requestUserPasswordReset(email: "${email}")
        }
      `
    }
  })
  .then(response => {
    return response
  })
  .catch(error => {
    axios.isCancel(error) ? console.log(`Request canceled: ${error}`) : console.log(error)
  })
}

export default requestResetPassword